/**
 * https://gist.github.com/szarsti/7122282
 * Mouse wheel polyfill inspired by cross-browser example on mdn wiki.
 *
 * It supports relatively modern browsers, which already support addEventListener and Array forEach methods.
 * Effectively it is targeting webkit based browsers. I didn't have opportunity to test it on old Firefox.
 * Method addEventListener is supported in IE9, which already supports wheel event. I guess one could combine
 * it with polyfill for addEventListener to have support in IE 6-8. In that case one would have to also wrap
 * all addEventListener methods provided by the polyfill (last block below).
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Reference/Events/wheel
 * TODO maybe usefull to dispatch custom event instead of using callback wrappers https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 * @see https://connect.microsoft.com/IE/feedback/details/782835/missing-onwheel-attribute-for-the-wheel-event-although-its-supported-via-addeventlistener
 */
if("onmousewheel" in document.createElement("div") && !("onwheel" in document.createElement("div") || document.implementation.hasFeature("Events.wheel", "3.0"))/* && "EventTarget" in window*/){
	window.WheelEvent = {
		DOM_DELTA_PIXEL: 0x00,
		DOM_DELTA_LINE: 0x01,
		DOM_DELTA_PAGE: 0x02,
		/**
		 * Create WheelEvent instance from MouseWheelEvent
		 * @param event
		 * @returns {event}
		 */
		fromEvent: function fromEvent(event){
			var deltaX = "wheelDeltaX" in event ? -1/40 * event.wheelDeltaX : 0;
			var deltaY = -1/40 * event.wheelDelta;
			return Object.create(event, {
				// delatX property
				deltaX: {
					value: deltaX,
					writable: false
				},
				// delatY property
				deltaY: {
					value: deltaY,
					writable: false
				},
				// delatZ property
				deltaZ: {
					value: 0,
					writable: false
				},
				// deltaMode property
				deltaMode: {
					value: event.type == "MozMousePixelScroll" ? 0 : 1,
					writable: false
				},
				// event type property
				type: {
					value: "wheel",
					writable: false
				},
				// preventDefault method
				// Chrome complains when native methods are called with custom events
				preventDefault: {
					value: function preventDefault() {
						Object.getPrototypeOf(this).preventDefault();
					}
				}
			});
		},
		__polyfill_wheel_callback_count: 0
	};

	// EventTarget.prototype is not available in WebKit/Safari (but in WebKit/Chrome)
	//Node and Window
	[Node.prototype, Window.prototype].forEach(function interceptEventTargetMethods(proto) {
		// Save original methods
		var addEventListenerNative = proto.addEventListener,
			removeEventListenerNative = proto.removeEventListener;
		// Override addEventListener method
		proto.addEventListener = function addEventListener(name, callback, useCapture) {
			if (name == "wheel") {
				// Override event type
				name = "mousewheel";
				// Save original callback
				var _callback = callback;
				// Get or generate callback ID
				var callbackID = _callback.__polyfill_wheel_callback_id = _callback.__polyfill_wheel_callback_id || ("callback" + WheelEvent.__polyfill_wheel_callback_count++);
				// Override callback (and attach it to EventTarget/this)
				callback = (this.__polyfill_wheel_callbacks = this.__polyfill_wheel_callbacks || {})[callbackID] = function (event){
					// Override with WheelEvent instance from the MouseWheelEvent
					event = WheelEvent.fromEvent(event);

					// Call callback
					// as Function
					if (typeof _callback == "function") {
						return _callback(event);
					}
					// as EventListener
					else if (_callback.handleEvent) {
						return _callback.handleEvent.call(_callback, event);
					}
				};
			}
			// Call native method with our event handler
			return addEventListenerNative.call(this, name, callback, useCapture);
		};
		// Override removeEventListener method
		proto.removeEventListener = function removeEventListener(name, callback, useCapture){
			if (name == "wheel") {
				name = "mousewheel";

				// Get callback ID
				var callbackID = callback.__polyfill_wheel_callback_id;
				var handler = this.__polyfill_wheel_callbacks[callbackID];
				if (handler) {
					// Remove callback to EventTarget/this
					delete this.__polyfill_wheel_callbacks[callbackID];
					// Override callback
					callback = handler;
				}
			}
			return removeEventListenerNative.call(this, name, callback, useCapture);
		};
	});
}
